<template>
    <div class="graphCalendar" @click="()=>{initGradiantPrimaryColor(),updateChat()}">
          <canvas :id="id" :width="500 * 2" :height="400"></canvas>
      </div>
  </template>
  
  <script>
  export default {
      props: {
        id: {
            type: String,
            default: 'graphCalendar'
        },
        primaryColor: {
            type: Array,
            default: function() {
                return [107, 31, 77];
            }
        },
        data: {
            type: Array,
            default: function() {
                return this.generateData();
            }
        },
        optimalTimes: {
            type: Array
        },
      },
  
      data() {
              return {
                  chart: null,
                  gradiantPrimaryColorHsl : [],
              }
          },
  
          mounted () {
              this.initGradiantPrimaryColor()
              this.createChart()
              
          },
  
          watch: {
              data() {
                  this.initGradiantPrimaryColor()
                  this.updateChat()
              },
  
              labels() {
                  this.initGradiantPrimaryColor()
                  this.updateChat()
              },
          },
  
          methods: {
              createChart() {
           
                let minImpRate = -(this.optimalTimes.minImpRate) 
                let maxImpRate = this.optimalTimes.maxImpRate
                  // eslint-disable-next-line no-undef
                  this.chart = new Chart(this.id, {
                  
                    type: 'matrix',
                    data : {
                        datasets: [{
                            label: 'My Matrix',
                            data: this.generateData(),

                            backgroundColor(context) {
                                const value = context.dataset.data[context.dataIndex].v;
                                return `rgba(107, 31, 77, ${value/100} )`;
                            },
                            borderColor(context) {
                                const value = context.dataset.data[context.dataIndex].v;
                                const alpha = (value - 5) / 40;
                                return '#f1edf5';
                            },
                            borderWidth: 0.5,
                      
                            width: ({chart}) => (chart.chartArea || {}).width / 7,
                            height: ({chart}) =>(chart.chartArea || {}).height / 24
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: false,
                            tooltip: {
                            callbacks: {
                                title() {
                                    return '';
                                },
                                    label(context) {
                                    const v = context.dataset.data[context.dataIndex];
                                    return ['x: ' + v.x, 'y: ' + v.y, 'v: ' + v.v];
                                }
                            }
                            }
                        },
                        scales: {
                            x: {
                                ticks: {
                                    stepSize: 1,
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    callback(value) {
                                        return  ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche'][parseInt(value)-1];
                                    }
                                },
                                grid: {
                                    display: false,
                                    drawBorder: false,
                                }
                            },
                                y: {
                                offset: true,
                                ticks: {
                                    stepSize: 1,
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks

                                    callback(value) {
                                        return (value-1)%3 == 0 ? Math.abs(value-1)+'h' : '';
                                    }
                                },
                                grid: {
                                    display: false
                                }
                            }
                        }
                    }

                  })
                  console.log("createChartt",this.chart )
              },
              updateChat() {
                  
                  this.chart.update()
                  console.log("chart",this.chart)
              },
              
              initGradiantPrimaryColor() {
                  //itialise une liste de couleur prenant la couleur primaire comme reference,
                  //Les couleurs sont de plus en plus claire
                  //Nous calculons le nombre de data de type bar afin de favoriser une meilleur variété de couleur
                  //ex 4 data type bar, alors 4 couleurs
                  //Les dégradé de couleur sert qu'un type bars
  
                  let countDataTypeBar = 8//this.data.filter((d) => d.type == 'bar').length;
                  let colorHsl = this.rgbToHsl(this.primaryColor[0], this.primaryColor[1], this.primaryColor[2])
  
                  if (colorHsl[2] + 20*(countDataTypeBar-1) > 90) {
                      colorHsl[2] = 100 - 20*countDataTypeBar
                  }
              
                  this.gradiantPrimaryColorHsl = [colorHsl]
                  for (let i = 2; i <= countDataTypeBar; i++) {
                      this.gradiantPrimaryColorHsl.push([colorHsl[0],colorHsl[1],this.gradiantPrimaryColorHsl[this.gradiantPrimaryColorHsl.length-1][2] + 10])
                  }
  
              },
              rgbToHsl(r, g, b){
                  r /= 255;
                  g /= 255;
                  b /= 255;
                  const l = Math.max(r, g, b);
                  const s = l - Math.min(r, g, b);
                  const h = s
                      ? l === r
                      ? (g - b) / s
                      : l === g
                      ? 2 + (b - r) / s
                      : 4 + (r - g) / s
                      : 0;
                  return [
                      60 * h < 0 ? 60 * h + 360 : 60 * h,
                      100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
                      (100 * (2 * l - s)) / 2,
                  ];
              },

              generateData() {
                const values = this.data.flat()
                const maxValue = Math.max(...values.flat())
                const multiplier = 100/maxValue

                const data = [];
                for (let day = 1; day <= 7; day++) {
                    for (let hours = 1; hours <= 24; hours++) {
                        data.push({
                            x: day,
                            y: hours,
                            v: this.data ? this.data[day-1][hours-1] * multiplier : 0
                        });
                    }
                }
                
                return data;
            }
          },
  }
  </script>
